// @ts-check
import {
  currentOrPastDateUI,
  currentOrPastDateSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(
      'What was your last date of attendance at the closed or disapproved school or in the suspended program?',
    ),
    lastDateOfAttendance: {
      ...currentOrPastDateUI({
        title: 'Your last date of attendance',
        hint: 'If you are not sure of the exact date, enter the approximate date.',
        required: () => true,
        monthSelect: false,
        removeDateHint: true,
      }),
      'ui:errorMessages': {
        required: 'You must enter a date',
        pattern: 'Enter a valid date',
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      lastDateOfAttendance: currentOrPastDateSchema,
    },
    required: ['lastDateOfAttendance'],
  },
};
